import dynamic from "next/dynamic";
import React from "react";
import Head from "next/head";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const Apply = dynamic(() => import("@/components/careers/apply"), {
  ssr: false,
});

const ApplyPage = ({ id }: any) => {
  return (
    <>
      <Head>
        <title>{seoData.CAREERS_JOBS_APPLY.title}</title>
        <SeoMetaData data={seoData.CAREERS_JOBS_APPLY} />
      </Head>

      <Apply jobId={id} />
    </>
  );
};

export async function getServerSideProps(context: any) {
  const { id } = context.params;

  return {
    props: { id }, // will be passed to the page component as props
  };
}

export default ApplyPage;
